import { createFileRoute } from "@tanstack/react-router";
import { fetchSettings } from "@/lib/api";

export const Route = createFileRoute("/terms-conditions")({
  loader: async ({ context: { queryClient } }) => {
    return await queryClient.ensureQueryData({
      queryKey: ["settings"],
      queryFn: fetchSettings,
    });
  },
  head: ({ loaderData }) => {
    const settings = loaderData as any;
    const siteName = settings?.site_name || "Lihar Aksara";
    const canonicalUrl = "https://liharaksara.web.id/terms-conditions";
    return {
      meta: [
        { title: `Terms & Conditions — ${siteName}` },
        { name: "description", content: `Syarat dan Ketentuan penggunaan layanan di ${siteName}.` },
        { property: "og:title", content: `Terms & Conditions — ${siteName}` },
        { property: "og:url", content: canonicalUrl },
      ],
      links: [{ rel: "canonical", href: canonicalUrl }],
    };
  },
  component: TermsPage,
});

function TermsPage() {
  return (
    <div className="container-prose py-16 md:py-24">
      <h1 className="font-serif text-4xl md:text-5xl font-medium mb-8">Terms & Conditions</h1>
      <div className="prose prose-slate max-w-none font-serif text-lg leading-relaxed text-slate-700 dark:text-slate-300">
        <h2><strong>Syarat dan Ketentuan</strong></h2>
        <p>Terakhir diperbarui: 23 Mei 2026</p>
        <p>Dengan mengakses dan menggunakan <a href="https://liharaksara.web.id">Lihar Aksara</a>, Anda dianggap telah menyetujui seluruh syarat dan ketentuan berikut.</p>
        
        <h3><strong>Penggunaan Website</strong></h3>
        <p>Pengguna setuju menggunakan website ini hanya untuk tujuan yang sah dan tidak melanggar hukum.</p>
        <p>Dilarang:</p>
        <ul>
          <li>menyalahgunakan website,</li>
          <li>melakukan spam,</li>
          <li>mencoba merusak sistem,</li>
          <li>atau menggunakan website untuk aktivitas ilegal.</li>
        </ul>

        <h3><strong>Hak Cipta dan Kekayaan Intelektual</strong></h3>
        <p>Seluruh artikel, novel, cerita, karakter, ilustrasi, dan karya tulis lainnya di website ini merupakan milik pemilik website kecuali disebutkan lain.</p>
        <p>Dilarang:</p>
        <ul>
          <li>menyalin seluruh isi konten tanpa izin,</li>
          <li>menerbitkan ulang karya,</li>
          <li>mengubah atau mendistribusikan konten,</li>
          <li>menggunakan karya untuk kepentingan komersial tanpa izin tertulis.</li>
        </ul>

        <h3><strong>Konten Novel dan Karya Fiksi</strong></h3>
        <p>Seluruh karya novel dan cerita yang dipublikasikan di website ini dilindungi oleh hak cipta.</p>
        <p>Kemiripan nama, tempat, kejadian, atau karakter dengan dunia nyata bersifat tidak disengaja kecuali disebutkan secara jelas.</p>

        <h3><strong>Komentar Pengguna</strong></h3>
        <p>Pengguna bertanggung jawab penuh atas komentar atau konten yang dikirimkan ke website.</p>
        <p>Kami berhak menghapus komentar yang mengandung:</p>
        <ul>
          <li>spam,</li>
          <li>ujaran kebencian,</li>
          <li>pornografi,</li>
          <li>pelecehan,</li>
          <li>atau pelanggaran hukum lainnya.</li>
        </ul>

        <h3><strong>Perubahan Konten</strong></h3>
        <p>Kami dapat mengubah, memperbarui, atau menghapus isi website kapan saja tanpa pemberitahuan terlebih dahulu.</p>

        <h3><strong>Batas Tanggung Jawab</strong></h3>
        <p>Kami tidak bertanggung jawab atas kerugian, kerusakan, kehilangan data, atau masalah lain yang timbul akibat penggunaan informasi dari website ini.</p>
      </div>
    </div>
  );
}
